// Monta as páginas de cidade e de streaming a partir de seoSitemapData.json.
// Sem imports: também é usado por scripts/prerender-seo.mjs no build.

export const SITE_URL = "https://www.settefibra.com.br";

const cityLabelOf = (city) =>
  `${city.name}${city.state ? ` - ${city.state}` : ""}`;

export const cityPath = (city) => `/internet-fibra-${city.slug}`;

export const buildCityPage = (city, cities = []) => {
  const cityLabel = cityLabelOf(city);
  const nearby = cities.filter((item) => item.slug !== city.slug);

  return {
    path: cityPath(city),
    title: `Internet Fibra Óptica em ${city.name} | Sette Fibra`,
    description: `Internet fibra óptica em ${cityLabel} com velocidade real, Wi-Fi estável, instalação ágil e suporte local. Consulte a cobertura e os planos da Sette Fibra.`,
    eyebrow: `Internet fibra em ${city.name}`,
    h1: `Internet fibra óptica em ${city.name}`,
    lead: `A Sette Fibra leva internet 100% fibra óptica para casas e empresas em ${cityLabel}, com velocidade real, estabilidade em horário de pico e atendimento de quem é da região.`,
    ctaText: `Consultar cobertura em ${city.name}`,
    areaServed: cityLabel,
    cityName: city.name,
    sections: [
      {
        title: `Por que contratar internet fibra em ${city.name}`,
        paragraphs: [
          `Na fibra óptica o sinal viaja por luz, sem a interferência e a perda de qualidade das conexões antigas a cabo ou via rádio. Para quem mora ou trabalha em ${city.name}, isso significa velocidade constante, menos quedas e resposta rápida em jogos e chamadas de vídeo.`,
          "A rede da Sette Fibra chega com fibra até o seu endereço, então vários celulares, Smart TVs e computadores podem usar a internet ao mesmo tempo sem disputar velocidade.",
        ],
        list: [
          "Streaming em 4K sem travar.",
          "Home office e aulas online com chamadas estáveis.",
          "Jogos online com baixa latência.",
          "Upload rápido para enviar arquivos e fazer backup.",
        ],
      },
      {
        title: `Planos para casa e para empresa em ${city.name}`,
        paragraphs: [
          "Para residências, a escolha depende de quantas pessoas usam a internet e do que fazem: séries, redes sociais, jogos ou trabalho remoto. Nosso time indica a velocidade certa para não pagar por mais do que precisa.",
          `Para comércios, escritórios e clínicas em ${city.name}, a prioridade é estabilidade para sistemas, maquininhas, câmeras e atendimento ao cliente, com suporte rápido quando for preciso.`,
        ],
      },
      {
        title: "Como contratar",
        paragraphs: [
          "A contratação é simples e feita com uma pessoa do nosso time, sem robô.",
        ],
        list: [
          `Fale com a Sette Fibra e informe seu endereço em ${city.name}.`,
          "Confirmamos a cobertura e indicamos o plano ideal para a sua rotina.",
          "Agendamos a instalação com a nossa equipe técnica.",
        ],
        cta: { type: "whatsapp", label: `Consultar cobertura em ${city.name}` },
      },
    ],
    faq: [
      {
        question: `A Sette Fibra tem cobertura em todo o município de ${city.name}?`,
        answer: `A Sette Fibra atende ${cityLabel}, e a disponibilidade varia por rua e bairro. Informe seu endereço ao nosso time para confirmar a cobertura no seu local.`,
      },
      {
        question: "A internet da Sette Fibra é 100% fibra óptica?",
        answer:
          "Sim. A conexão chega por fibra óptica até o seu endereço, o que garante mais estabilidade e velocidade constante do que conexões a cabo ou via rádio.",
      },
      {
        question: "Como faço para contratar?",
        answer:
          "Fale com a Sette Fibra pelo chat do site ou pelo WhatsApp, informe seu endereço e escolha o plano. Nosso time agenda a instalação com você.",
      },
      {
        question: "Tem plano para empresa?",
        answer: `Sim. Atendemos comércios, escritórios e clínicas em ${city.name} com planos empresariais pensados para sistemas, câmeras e atendimento ao cliente.`,
      },
    ],
    links: [
      { label: "Ver planos", to: "/#plans" },
      ...nearby.map((item) => ({
        label: `Internet fibra em ${item.name}`,
        to: cityPath(item),
      })),
      { label: "Internet empresarial em Anápolis", to: "/internet-empresarial-anapolis" },
      { label: "Blog da Sette Fibra", to: "/blog" },
    ],
  };
};

// As 30 páginas de streaming são quase iguais entre si: ficam fora do índice
// do Google (noindex) para não contarem como conteúdo raso contra o site.
export const buildStreamingPage = (streaming) => ({
  path: `/streaming/${streaming.slug}`,
  noindex: true,
  title: `${streaming.name} com internet fibra | Sette Fibra`,
  description: `Assine a internet fibra da Sette Fibra e aproveite ${streaming.name} como benefício. ${streaming.summary}`.slice(0, 300),
  eyebrow: "Benefício digital",
  h1: `${streaming.name} com a Sette Fibra`,
  lead: `${streaming.summary} Com a internet fibra da Sette Fibra, você assiste com estabilidade e conta com atendimento local.`,
  ctaText: "Falar com um vendedor",
  areaServed: "Goiás",
  sections: [
    {
      title: `Sobre o ${streaming.name}`,
      paragraphs: [
        streaming.summary,
        "Esse benefício faz parte das vantagens que deixam o seu plano mais completo.",
      ],
    },
    {
      title: "Por que assistir com internet fibra",
      paragraphs: [
        `Streaming em alta resolução precisa de velocidade constante. Com fibra óptica, o ${streaming.name} carrega rápido e não fica trocando de qualidade no meio do episódio.`,
      ],
      list: [
        "Mais conteúdo para você e sua família.",
        "Internet fibra estável para assistir sem interrupções.",
        "Ativação simples com suporte humano.",
      ],
    },
    {
      title: "Pronto para ativar seu benefício?",
      paragraphs: [
        "Fale com um vendedor para saber quais planos incluem o benefício, as regras de ativação e a disponibilidade no seu endereço.",
      ],
      cta: { type: "whatsapp", label: "Falar com um vendedor" },
    },
  ],
  links: [
    { label: "Ver planos", to: "/#plans" },
    { label: "Internet fibra em Anápolis", to: "/internet-fibra-anapolis" },
    { label: "Blog da Sette Fibra", to: "/blog" },
  ],
});
